/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_No_Changes_To_SubmitInputs */

const en_audit_no_changes_to_submit = /** @type {(inputs: Audit_No_Changes_To_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No changes to submit — adjust actual counts that differ from expected`)
};

const es_audit_no_changes_to_submit = /** @type {(inputs: Audit_No_Changes_To_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay cambios para enviar — ajuste los conteos reales que difieran de lo esperado`)
};

/**
* | output |
* | --- |
* | "No changes to submit — adjust actual counts that differ from expected" |
*
* @param {Audit_No_Changes_To_SubmitInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_no_changes_to_submit = /** @type {((inputs?: Audit_No_Changes_To_SubmitInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_No_Changes_To_SubmitInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_no_changes_to_submit(inputs)
	return es_audit_no_changes_to_submit(inputs)
});